import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var trending_down_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4.195 8.245a.75.75 0 011.06-.05l5.004 4.55 4.025-3.521L19 13.939V10.75h1.5v5.75h-5.75V15h3.19l-3.724-3.723-3.975 3.478-5.995-5.45a.75.75 0 01-.051-1.06z" }) });
export {
  trending_down_default as default
};
//# sourceMappingURL=trending-down.js.map
